import { createRoute } from '@tanstack/react-router'
import { EditCollectionPage } from '@/features/collections/pages/EditCollectionPage'
import { Route as collectionsRoute } from '../../collections'

export const Route = createRoute({
  getParentRoute: () => collectionsRoute,
  path: '/edit/$id',
  component: EditCollectionPage,
})
